// 呼叫端明確指定的 project-id 優先：sessionStorage 只記「最後一次查過的專案」，
// 在 60 秒 query 快取內從專案 A→B→A 切回時不會重寫，會帶到 B 的 id（2026-10 結帳頁 Codex review）
export const resolveProjectIDHeader = (
  explicit: unknown,
  stored: string | null,
): string | undefined =>
  (typeof explicit === 'string' && explicit) || stored || undefined;
